import { Alert, Col, Progress, Row, Space } from 'antd'
import CIMSSection from '../../../../../../../../../../components/CIMSSection'
import CIMSBasicFields from '../../../../../../../../../../components/CIMSBasicFields'
import { CSVImportLatestJobResponse, JobStatus } from 'shared'
import { dateFormatter } from '../../../../../../../../../../utils/dateFormatter'

interface ResultsSummaryProps {
  title?: string
  created: number
  edited: number
  errors: number
  progress: number
  job: NonNullable<CSVImportLatestJobResponse['job']>
}

function ResultsSummary({
  created,
  edited,
  errors,
  progress,
  job,
}: ResultsSummaryProps) {
  return (
    <CIMSSection
      title={`Latest import results: ${job.input?.filename ?? 'Unknown file'}`}
    >
      <Space direction="vertical" size="large" style={{ display: 'flex' }}>
        {job.statusId === JobStatus.Failed.id && (
          <Alert
            message="Import failed"
            description={`Something went wrong during the CSV import of "${
              job.input?.filename
            }", which started on ${dateFormatter.simple(job.createdDate)}: "${
              job.error?.message
            }"`}
            type="error"
            showIcon
          />
        )}

        <Row justify="space-between" align={'middle'}>
          <Col>
            <Space direction="vertical" size="middle">
              <CIMSBasicFields
                fields={[
                  {
                    label: 'Created',
                    children: created.toLocaleString(),
                    help: 'Number of records created',
                  },
                  {
                    label: 'Edited',
                    children: edited.toLocaleString(),
                    help: 'Number of records edited',
                  },
                  {
                    label: 'Errors',
                    children: errors.toLocaleString(),
                    help: 'Number of records not imported due to error',
                  },
                ]}
              />
            </Space>
          </Col>
          <Col>
            <Progress
              status={
                job.statusId === JobStatus.Failed.id ? 'exception' : undefined
              }
              type="circle"
              percent={progress}
            />
          </Col>
        </Row>
      </Space>
    </CIMSSection>
  )
}

export default ResultsSummary
